// extracted by mini-css-extract-plugin
module.exports = {"light":"scope_light__P_B2T","dark":"scope_dark__xTSVR"};